export default "__VITE_ASSET__CbK2Ar1___"